/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Sidebar_Usage_Near_LimitInputs */



/**
* | output |
* | --- |
* | "Almost out — resets at {time}" |
*
* @param {Sidebar_Usage_Near_LimitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sidebar_usage_near_limit = /** @type {((inputs: Sidebar_Usage_Near_LimitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Usage_Near_LimitInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Fast aufgebraucht — Reset um ${i?.time}`)
	return /** @type {LocalizedString} */ (`Almost out — resets at ${i?.time}`)
});